<template>
  <div class="">
    <ZnBreadcrumb />
    <div class="main-content" v-title data-title="我的订单_试剂采购库存管理系统">
      <div class="search-type">
        <ul class="clearfix">
          <li>
            <div class="search-item">
              <el-input
                  v-model="alias"
                  placeholder="请输入订单编号/试剂名称/CAS号"
                  style="width: 259px"
                  prefix-icon="el-icon-search"
              />

              <el-select v-model="orderStatus" placeholder="订单状态" style="width: 110px;margin-left: 15px">
                <el-option
                    v-for="item in orderOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>


              <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 300px;margin-left: 15px"
                  v-model="queryTime"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
              <span class="searchButton">
                <el-button type="primary" size="small" style="background: #478aff;
            border-radius: 4px;font-size: 12px;color: #fff;margin-left: 20px;margin-right: 20px;" @click="getOrderList()">快速查询</el-button>
              </span>

<!--              <span v-show="orderExcelShow">-->
<!--                <el-button size="small" @click="handleMyOrderExport">-->
<!--                导出Excel-->
<!--              </el-button>-->
<!--              </span>-->
            </div>

          </li>
        </ul>
      </div>
      <div class="inventory-library table-container">
        <div class="no-date" v-if="myAllOrder.length == 0">
          <div>
            <img src="../../assets/images/empty.png" alt="" />
            <p>暂无订单</p>
          </div>
        </div>

        <!-- :span-method="objectSpanMethod" -->
        <el-table
          v-else
          :span-method="objectSpanMethod"
          :data="myAllOrder"
          :header-cell-style="{background: '#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight: 700,height: '54px',}"
          border
          style="width: 100%">
          <el-table-column prop="lockerOrders.orderNo" label="订单编号" width="190px">
          </el-table-column>
          <el-table-column prop="lockerOrders.orderTime" label="下单时间" width="110px" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="lockerOrders.auditTime" label="审核时间" width="110px" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="supplierBrand" label="品牌"></el-table-column>
          <el-table-column prop="goodsName" label="试剂名称"> </el-table-column>
          <el-table-column prop="casNo" label="CAS号"> </el-table-column>
<!--          <el-table-column prop="casNo" label="结构式">-->
<!--            <template slot-scope="scope">-->
<!--              <el-image style="width:50px;height:50px;" class="structionImg" :src="scope.row.structionImg" alt="" :preview-src-list="[scope.row.structionImg]">-->
<!--                <div slot="error" class="image-slot" >-->
<!--                  <div style="width: 50px;height: 50px;line-height: 50px;text-align: center;background-color:#f5f7fa;color: #c0c4cc" >暂无</div>-->
<!--                </div>-->
<!--              </el-image>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="购买剂量">
            <template slot-scope="scope">
              <span v-if="scope.row.lockerOrders.orderType == 1">
                {{ scope.row.packageType }}
              </span>
              <span v-if="scope.row.lockerOrders.orderType == 0">
                {{ scope.row.weight }} {{ $store.state.unit[scope.row.weightUnit] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="购买量">
          </el-table-column>
          <el-table-column prop="salesPriceTask" label="单价">
            <template slot-scope="scope">
              <span v-if="scope.row.unitPrice">{{ scope.row.unitPrice }} 元</span>
              <span v-else>{{ scope.row.salesPriceTask }} 元</span>
            </template>
          </el-table-column>
          <el-table-column prop="lockerOrders.freightActual" label="运费">
            <template slot-scope="scope">
              <span >{{scope.row.lockerOrders.freightActual}} 元</span>
            </template>
          </el-table-column>
          <el-table-column prop="lockerOrders.orderAmount" label="总金额">
            <template slot-scope="scope">
              <span v-if="scope.row.lockerOrders.orderfreightAmount">{{scope.row.lockerOrders.orderfreightAmount}} 元</span>
              <span v-else>{{ scope.row.lockerOrders.orderAmount}} 元</span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态">
            <template slot-scope="scope">
              <span v-if="scope.row.lockerOrders.auditStatus == 1" style="color: #F18F41">{{ scope.row.lockerOrders.auditStatusText }}</span>
              <span v-else>{{ scope.row.lockerOrders.auditStatusText }}</span>
              <el-tooltip class="item" effect="dark" :content="null !=scope.row.lockerOrders.refusalReason?scope.row.lockerOrders.refusalReason:'暂无备注内容'"
                          width="200" style="margin-left: 5px" v-show="scope.row.lockerOrders.auditStatus == 3" placement="right-start">
                <span><i slot="reference" class="el-icon-warning"></i></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.lockerOrders.orderStatusText }}
                  <el-tooltip class="item" effect="dark" :content="null !=scope.row.lockerOrders.calReason?scope.row.lockerOrders.calReason:'暂无备注内容'"
                              width="200" style="margin-left: 5px"
                              v-show="scope.row.lockerOrders.orderStatus == 5" placement="right-start">
                <span><i slot="reference" class="el-icon-warning"></i></span>
              </el-tooltip>
              </span>

            </template>
          </el-table-column>
          <el-table-column label="开票状态">
            <template slot-scope="scope">
              <span v-if="scope.row.invoiceNum">
                <el-tooltip class="item" effect="dark" :content="'票号：'+scope.row.invoiceNum" placement="top-start">
                <span v-if="scope.row.invoiceNum">已开票</span>
              </el-tooltip>
              </span>

              <span v-else>未开票</span>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="bindingStatusText" label="绑定状态">-->
          <!--          </el-table-column>-->
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <img
                @click="goodsDetails(scope.row)"
                src="../../assets/private/商品详情.png"
                title="商品详情"
                style="height: 25px; width: 25px; float: left"
              />

              <el-popover
                placement="top-start"
                v-if="scope.row.lockerOrders.orderStatus == 2 || scope.row.lockerOrders.orderStatus == 3 || scope.row.lockerOrders.orderStatus == 4"
                trigger="click"
              >
                <p style="font-size: 13px; font-weight: 700">物流详情</p>
                <p>快递公司：{{ scope.row.lockerOrders.expressName }}</p>
                <p>快递单号：{{ scope.row.lockerOrders.expressNo }}</p>

                <img
                  slot="reference"
                  src="../../assets/private/物流.png"
                  title="物流详情"
                  style="height: 25px; width: 25px; float: left;margin-left: 6px;"
                />
              </el-popover>

              <img
                @click="comfirmReceived(scope.row)"
                v-if="scope.row.lockerOrders.orderStatusText == '已发货'"
                src="../../assets/private/确认收货.png"
                title="确认收货"
                style="height: 25px; width: 25px; float: left;margin-left: 6px;"
              />

              <img
                @click="delOrder(scope.row)"
                v-if="
                  scope.row.lockerOrders.orderStatusText == '订单取消' ||
                  scope.row.lockerOrders.auditStatusText == '未通过'
                "
                src="../../assets/private/del.png"
                title="删除"
                style="height: 25px; width: 25px; float: left;margin-left: 6px;"
              />

<!--              <img-->
<!--                @click="changeBind(scope.row)"-->
<!--                v-if="scope.row.lockerOrders.orderStatusText == '待入库'"-->
<!--                src="../../assets/private/update.png"-->
<!--                title="修改绑定"-->
<!--                style="height: 25px; width: 25px; float: left"-->
<!--              />-->

              <img
                @click="quxiao(scope.row)"
                v-if="scope.row.lockerOrders.orderStatusText == '订单待确认'"
                src="../../assets/private/取消订单.png"
                title="取消订单"
                style="height: 25px; width: 25px; float: left;margin-left: 6px;"
              />
            </template>
          </el-table-column>
        </el-table>
        <!-- 修改绑定弹框 -->
        <el-dialog
          title="修改绑定"
          :visible.sync="dialogChange"
          class="changeDia"
          width="460px"
        >
          <p>
            请复制本订单编号
            <span>{{ changeBindContent }}</span>
            在[试剂管理]页面对每个药剂进行操作
          </p>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogChange = false">取 消</el-button>
            <el-button type="primary" @click="dialogChange = false"
              >确 定</el-button
            >
          </div>
        </el-dialog>
        <Pagination
          :dataTotal="total"
          :totalpage="totalpage"
          :pagesize="pagesdata.pageSize"
          @changePage="changePage"
        ></Pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {EventBus} from "@/config/event-bus";

export default {
  data() {
    return {
      auditAmount:{
        //总金额
        totalAmount:null,
        //待审核金额
        waitAmount:null,
        //通过金额
        successAmount:null,
        //驳回金额
        failAmount:null,
        //采购量
        reagentNum:null,
      },
      queryTime: null,
      changeBindContent: "",
      dialogChange: false,
      alias: "",
      total: 0,
      orderStatus: "",
      formLabelWidth: "120px",
      content: "",
      myAllOrder: [],

      howWidth: 12,
      totalpage: 0,
      pagesdata: {
        pageNum: 1,
        pageSize: 10,
      },
      spanArr: [], //遍历数据时，根据相同的标识去存储记录
      position: 0, // 二维数组的索引
      mergeColIndex: [0, 1,2, 9,10,11,12,13,14], // 要合并的列的序号，从0 开始
      orderExcelShow: false,
      orderOptions: [
        {
          value: "",
          label: "请选择",
        },
        {
          value: "1",
          label: "待发货",
        },
        {
          value: "2",
          label: "已发货",
        },
        {
          value: "4",
          label: "已收货",
        },
        {
          value: "5",
          label: "订单取消",
        },
        {
          value: "6",
          label: "待确认",
        },
      ],
    };
  },
  created() {
    this.getOrderList();
    //this.getConfiguration();
  },
  methods: {
    tableRowStyle({row, rowIndex}){
      var orders = row.lockerOrders;
      if(6 == orders.orderStatus){
        let styleColor = {"color":"#F18F41"};
        return styleColor;
      }
    },
    //我的订单菜单 角标数量显示
    getConfirmOrder() {
      this.$apiFetch
          .get("/lockerOrders/getConfirmOrder")
          .then((res) => {
            localStorage.setItem("confirmOrder",res.data);
            EventBus.$emit('confirmOrder',res.data);
          });
    },
    getSpanArr(data) {
      this.spanArr = []; // 避免表格错乱！
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (
            data[index].lockerOrders.orderNo ===
            data[index - 1].lockerOrders.orderNo
          ) {
            // 这里是要合并行
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      });
    },
    // 表格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.mergeColIndex.indexOf(columnIndex) != -1) {
        // 对第一列进行合并
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },

    getOrderList() {
      let startTime = '';
      let endTime = '';
      if(null != this.queryTime && this.queryTime.length > 0){
        startTime = this.queryTime[0];
        endTime = this.queryTime[1];
      }
      let alias = this.alias;
      let orderStatus = this.orderStatus;
      let pageSize = this.pagesdata.pageSize;
      let pageNum = this.pagesdata.pageNum;
      this.$apiFetch
        .get(
          `/lockerOrders?alias=${alias}&orderStatus=${orderStatus}&startTime=${startTime}&endTime=${endTime}&pageSize=${pageSize}&pageNum=${pageNum}`
        )
        .then((res) => {
          res.data.list.map((item) => {
            item.visible = false;
            if (item.lockerOrders.auditStatus == 1 && item.lockerOrders.orderStatus == 1) {
              item.lockerOrders.orderStatus = "-";
            }
            if (item.lockerOrders.orderStatus == 0) {
              item.lockerOrders.orderStatusText = "订单待确认";
            } else if (item.lockerOrders.orderStatus == 1) {
              item.lockerOrders.orderStatusText = "待发货";
            } else if (item.lockerOrders.orderStatus == 2) {
              item.lockerOrders.orderStatusText = "已发货";
            } else if (item.lockerOrders.orderStatus == 3) {
              item.lockerOrders.orderStatusText = "已完成";
            } else if (item.lockerOrders.orderStatus == 4) {
              // item.lockerOrders.orderStatusText = "已完成";
              item.lockerOrders.orderStatusText = "已完成";
            } else if (item.lockerOrders.orderStatus == 5) {
              item.lockerOrders.orderStatusText = "订单取消";
            } else if (item.lockerOrders.orderStatus == 6) {
              item.lockerOrders.orderStatusText = "订单待确认";
            } else if (item.lockerOrders.orderStatus == 10) {
              item.lockerOrders.orderStatusText = "洛济取消";
            }

            if (item.lockerOrders.auditStatus == 0) {
              item.lockerOrders.auditStatusText = "-";  // 不需要审核
            } else if (item.lockerOrders.auditStatus == 1) {
              item.lockerOrders.auditStatusText = "待审核";
              item.lockerOrders.orderStatusText = "-";
            } else if (item.lockerOrders.auditStatus == 2) {
              item.lockerOrders.auditStatusText = "已通过";
            } else if (item.lockerOrders.auditStatus == 3) {
              item.lockerOrders.auditStatusText = "未通过";
              item.lockerOrders.orderStatusText = "未生成订单";
            }else if (item.lockerOrders.auditStatus == 4) {
              item.lockerOrders.auditStatusText = "洛济取消";
            }else if (item.lockerOrders.auditStatus == 10) {
              item.lockerOrders.auditStatusText = "-";
            }

            if (item.lockerOrders.bindingStatus == 1) {
              item.lockerOrders.bindingStatusText = "已绑定";
            } else if (item.lockerOrders.bindingStatus == 2) {
              item.lockerOrders.bindingStatusText = "已解绑";
            } else {
              item.lockerOrders.bindingStatusText = "-";
            }
          });
          this.myAllOrder = res.data.list;
          this.getSpanArr(this.myAllOrder);
          this.total = res.data.total;
          this.totalpage = res.data.pages;
        });
      this.getConfirmOrder();
      this.orderAuditStatistics();
    },
    orderAuditStatistics(){
     var startTime = null;
      var endTime = null;
      if(null != this.queryTime && this.queryTime.length > 0){
        startTime = this.queryTime[0];
        endTime = this.queryTime[1];
      }
      this.$apiFetch
          .get(`/lockerOrders/orderAuditStatistics`,
              {alias: this.alias,userId:1000,startTime: startTime,endTime: endTime})
          .then((res) => {
            this.auditAmount = res.data;
          });
    },
    getConfiguration(){
      this.$apiFetch.get('/funConfig/getConfiguration').then((res) => {
        const data = res.data;
        for (let i = 0; i < data.length; i++) {
          //判断是否开通我的订单页导出功能
          if("MyOrderExcel" == data[i].functionType){
            this.orderExcelShow = true;
          }
        }
      });
    },
    //删除订单
    delOrder(row) {
      let id = row.ordersId;
      this.$apiFetch.delete(`/lockerOrders/${id}`).then(() => {
        this.getOrderList();
      });
    },
    //取消订单
    quxiao(row) {
      // let id = row.id;
      let id = row.ordersId;
      this.$apiFetch
        .get(`/lockerOrders/lockerOrdersQuxiao?id=${id}`)
        .then(() => {
          this.getOrderList();
        });
    },
    //商品详情
    goodsDetails(row) {
      let id = row.ordersId;
      let price = row.lockerOrders.orderAmountTask;
      let No = row.lockerOrders.orderNo;
      this.$router.push({
        path: `goodsDetailsGrzx/${id}?price=${price}&No=${No}`,
      });
      //查看订单详情时，查询角标数量
      this.getConfirmOrder();
    },
    comfirmReceived(row) {
      let id = row.ordersId;
      this.$apiFetch.get(`/lockerOrders/confirmReceiptOrder?id=${id}`).then(() => {
        this.getOrderList();

        //this.getConfirmOrder();
      });
    },
    //修改绑定
    changeBind(row) {
      console.log(row);
      this.dialogChange = true;
      this.changeBindContent = row.orderNo;
    },
    changePage(data) {
      this.pagesdata.pageNum = data;
      this.getOrderList();
    },
    handleMyOrderExport(){
      let startTime = '';
      let endTime = '';
      if(null != this.queryTime && this.queryTime.length > 0){
        startTime = this.queryTime[0];
        endTime = this.queryTime[1];
      }
      let alias = this.alias;
      let orderStatus = this.orderStatus;

      const data = {};
      data.startTime = startTime;
      data.endTime = endTime;
      data.alias = alias;
      data.orderStatus = orderStatus;
      const resp = this.$apiFetch
          .download("/lockerOrders/exportOrderExcel", data)
          .then((resp) => this.downloadFile(resp,'我的订单表'));
    },
  },
};
</script>
<style lang="less" scoped>
.no-date {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    display: block;
    width: 148px;
  }
  p {
    color: #b1c4e2;
    font-size: 14px;
    line-height: 20px;
    margin-top: 14px;
    text-align: center;
  }
}
.changeDia {
  p {
    font-size: 15px;
    span {
      color: #478aff;
    }
  }
}
// .main-content {
//   background-color: unset;
// }
/deep/.el-table .cell {
  button {
    margin-right: 20px;
  }
}
.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      position: relative;
      img {
        position: absolute;
        width: 14px;
        left: 9px;
        top: 11px;
      }
      input {
        width: 380px;
        padding-left: 28px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #cccccc;
      }
    }
  }
}
.table-container {
  border-radius: 4px;
  padding: 20px;
  background-color: #ffffff;
  .del-btn {
    color: #ff4d4f;
  }
}

.inventory-library {
  .table-handel {
    float: right;
    span {
      color: #666666;
      font-weight: normal;
      i {
        color: #fa8c16;
      }
    }
    span.to-see {
      padding-left: 24px;
      color: #333333;
      font-weight: 400;
      cursor: pointer;
    }
  }
}
.el-popover {
  p {
    color: #333333;
    font-size: 12px;
    line-height: 17px;
    padding-bottom: 8px;
  }
  button {
    display: block;
    margin: 0 auto;
  }
}
</style>

